<h2 class="fo-dialog-content" mat-dialog-title>
  {{ 'general.table-item-action.' + data.action | translate }}
  {{ 'admin.tenant-groups.group' | translate }}
</h2>
<mat-dialog-content>
  <form [formGroup]="form">
    <mat-tab-group
      mat-align-tabs="start"
      mat-stretch-tabs="false"
      [(selectedIndex)]="selectedTabIndex"
    >
      <mat-tab [label]="'admin.tenant-groups.form.tabs.general' | translate">
        <div class="tab-content tab-content_form">
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>{{ 'admin.tenant-groups.form.fields.group-name' | translate }}</mat-label>
            <input formControlName="name" matInput />
          </mat-form-field>
          <app-tenant-autocomplete-search
            formControlName="ownerTenantId"
            translationKey="admin.tenant-groups.form.fields.owner-tenant"
            [isIdOutput]="true"
            [isReadonly]="form.controls.ownerTenantId.disabled"
            [isRequired]="true"
          ></app-tenant-autocomplete-search>
          <flexyoo-tags-input
            formControlName="tenantsIds"
            [isFullWidth]="true"
            [items]="tenantsTags$ | async"
            [label]="'admin.tenant-groups.form.fields.tenants' | translate"
            [required]="true"
          >
          </flexyoo-tags-input>
        </div>
      </mat-tab>
      <mat-tab
        formGroupName="usersInfo"
        [disabled]="form.invalid"
        [label]="'admin.tenant-groups.form.tabs.permissions' | translate"
      >
        <div class="tab-content">
          <mat-accordion togglePosition="before" [multi]="true">
            @for (tenant of selectedTenants$ | async; track tenant.Id) {
              <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header class="expansion-panel-header">
                  <span class="expansion-panel-header-name">{{ tenant.Name }}</span>
                </mat-expansion-panel-header>
                <mat-panel-description>
                  <div class="fo-fill" [formGroupName]="tenant.Id.toString()">
                    @if (tenant.Users?.length) {
                      <div fxLayout="row" fxLayoutAlign="flex-end center" fxLayoutGap="10px">
                        <span class="checkbox-cell">{{
                          'admin.tenant-groups.form.fields.is-group-admin' | translate
                        }}</span>
                      </div>
                    }
                    @for (user of tenant.Users ?? []; track user.UserId) {
                      <div
                        fxLayout="row"
                        fxLayoutAlign="space-between center"
                        fxLayoutGap="10px"
                        [formGroupName]="user.UserId"
                      >
                        <span fxFlex="1 0 45%">{{ user.LastName }} {{ user.FirstName }}</span>
                        <mat-checkbox class="checkbox-cell" formControlName="isGroupAdmin">
                        </mat-checkbox>
                      </div>
                    }
                  </div>
                </mat-panel-description>
              </mat-expansion-panel>
            }
          </mat-accordion>
        </div>
      </mat-tab>
      <mat-tab
        [disabled]="form.invalid"
        [label]="'admin.tenant-groups.form.tabs.settings' | translate"
      >
        <div class="tab-content tab-content_settings" fxLayout="column">
          <mat-slide-toggle formControlName="useNextYearLegalDates">
            {{ 'admin.tenant-groups.form.fields.use-next-year-legal-dates' | translate }}
          </mat-slide-toggle>
          <mat-slide-toggle formControlName="useCustomPensionLegalDates">
            {{ 'admin.tenant-groups.form.fields.use-custom-pension-legal-dates' | translate }}
          </mat-slide-toggle>
          <div class="settings-row">
            <span
              class="settings-row__toggle"
              [matTooltip]="'admin.single-cart-validation.choice-period-warning' | translate"
              [matTooltipDisabled]="!isFirstChoicePeriodStarted"
            >
              <mat-slide-toggle formControlName="useSingleCartValidation">
                {{ 'admin.single-cart-validation.label' | translate }}
              </mat-slide-toggle>
            </span>
            @if (isFirstChoicePeriodStarted) {
              <span class="settings-row__warning" [style.color]="wls.warnColor">
                <mat-icon class="settings-row__warning-icon">warning</mat-icon>
                {{ 'admin.single-cart-validation.choice-period-warning' | translate }}
              </span>
            }
          </div>
          @if (isSingleCartValidationOn()) {
            <mat-slide-toggle formControlName="isHrApprovalRequired">
              {{ 'admin.hr-approval-required' | translate }}
            </mat-slide-toggle>
          }
          <mat-slide-toggle formControlName="useWhiteLabel">
            {{ 'admin.tenant-groups.form.fields.use-white-label' | translate }}
          </mat-slide-toggle>
        </div>
      </mat-tab>
    </mat-tab-group>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="fo-dialog-actions">
    <button class="fo-color-error" matButton="filled" type="button" (click)="closeDialog()">
      {{ 'general.cancel' | translate }}
    </button>
    @if (selectedTabIndex !== GroupFormTab.General) {
      <button
        class="fo-color-secondary"
        matButton="filled"
        type="button"
        (click)="selectedTabIndex = selectedTabIndex - 1"
      >
        {{ 'general.back' | translate }}
      </button>
    }
    @if (selectedTabIndex !== GroupFormTab.Settings) {
      <button
        class="fo-color-secondary"
        matButton="filled"
        type="button"
        [disabled]="form.invalid"
        (click)="selectedTabIndex = selectedTabIndex + 1"
      >
        {{ 'general.next' | translate }}
      </button>
    }
    @if (selectedTabIndex === GroupFormTab.Settings) {
      <button class="fo-color-secondary" matButton="filled" type="submit" (click)="saveBudget()">
        {{ 'general.save' | translate }}
      </button>
    }
  </div>
</mat-dialog-actions>

@if (isLoading$ | async) {
  <flexyoo-loader class="loader"></flexyoo-loader>
}
